import { FileCheckIcon } from './FileCheckIcon';

/**
 * author: Simran
 * id 9E66E6CF-74AD-4DB5-953B-DC135B4AD44C
 * name file-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-check.svg
 * tags
 * - Files / Folders 
 */
export const FileTickIcon = FileCheckIcon;
export default FileTickIcon